<h3 class="t-5@r color-jet mb-4">You need more Credits</h3>
<div class="t-8@r color-charcoal font-weight-500 mb-1">Buy more credits to Boost your message</div>
<div class="t-8@r color-ash mb-6">Your voice message was sent without a Boost.</div>
<button class="mb-4" sbButton [size]="'big'" [stretchable]="true" [variant]="'fill-gold'" (click)="confirm()">
  Buy Credits
</button>
